import React from 'react';
import { Edit, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { Talent } from '../../services/api';

interface TalentListProps {
  talenter: Talent[];
  onEdit: (talent: Talent) => void;
  onDelete: (id: number, navn: string, kategoriNavn?: string) => void;
}

const TalentList: React.FC<TalentListProps> = ({ talenter, onEdit, onDelete }) => {
  return (
    <div className="space-y-1 sm:space-y-2">
      {talenter.map(talent => (
        <div
          key={talent.id}
          className={cn(
            'flex flex-col sm:flex-row sm:items-center gap-2',
            'p-2 sm:p-3',
            'bg-card border rounded-lg',
            'hover:bg-accent/50 hover:shadow-sm transition-all'
          )}
        >
          {/* Talent navn - full bredde på mobil */}
          <div className="flex-1 min-w-0">
            <p className="text-sm sm:text-base font-medium text-foreground truncate">
              {talent.navn}
            </p>
            {talent.beskrivelse && (
              <p className="text-xs sm:text-sm text-muted-foreground truncate mt-0.5">
                {talent.beskrivelse}
              </p>
            )}
          </div>
          
          {/* Action buttons - kompakt på mobil */}
          <div className="flex items-center gap-1 sm:gap-2 self-end sm:self-auto">
            <Button 
              variant="ghost"
              size="icon"
              className="h-7 w-7 sm:h-8 sm:w-8 hover:bg-primary/10 text-primary shrink-0"
              onClick={() => onEdit(talent)}
            >
              <Edit className="h-3 w-3 sm:h-4 sm:w-4" />
            </Button>
            
            <Button 
              variant="ghost"
              size="icon"
              className="h-7 w-7 sm:h-8 sm:w-8 hover:bg-destructive/10 text-destructive shrink-0"
              onClick={() => onDelete(talent.id, talent.navn, talent.kategori_navn)}
            >
              <Trash2 className="h-3 w-3 sm:h-4 sm:w-4" />
            </Button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TalentList;

